export default __webpack_public_path__ + "static/media/blog-driveway-cost-003.48da6afd.jpg";